import { useState, useEffect } from "react";
import { User, Info, Phone, Users } from "lucide-react";
import Card from "../components/Card";

export default function ProfilePage() {
  const [callCount, setCallCount] = useState(0);
  const [clientCount, setClientCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const [callsRes, clientsRes] = await Promise.all([
        fetch("/api/calls"),
        fetch("/api/clients"),
      ]);

      if (callsRes.ok) {
        const calls = await callsRes.json();
        setCallCount(calls.length);
      }

      if (clientsRes.ok) {
        const clients = await clientsRes.json();
        setClientCount(clients.length);
      }
    } catch (error) {
      console.error("Error loading stats:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-slate-900">Profile</h2>

      <Card>
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-teal-500 to-teal-600 flex items-center justify-center shadow-sm">
            <User className="w-8 h-8 text-white" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-slate-900">Sales Professional</h3>
            <p className="text-sm text-slate-500">Using Sales Call Coach</p>
          </div>
        </div>
      </Card>

      <div className="grid grid-cols-2 gap-4">
        <Card>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center">
              <Phone className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-900">
                {isLoading ? "..." : callCount}
              </p>
              <p className="text-sm text-slate-500">Total Calls</p>
            </div>
          </div>
        </Card>
        <Card>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-emerald-50 flex items-center justify-center">
              <Users className="w-5 h-5 text-emerald-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-900">
                {isLoading ? "..." : clientCount}
              </p>
              <p className="text-sm text-slate-500">Clients</p>
            </div>
          </div>
        </Card>
      </div>

      <Card>
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center flex-shrink-0">
            <Info className="w-5 h-5 text-slate-600" />
          </div>
          <div>
            <h3 className="font-semibold text-slate-900 mb-2">About This App</h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              Sales Call Coach helps you prepare for, conduct, and follow up on
              client meetings with AI-powered insights. Your data is stored securely
              in a database and can sync with Spark OS.
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}
